import { useState, useEffect } from "react";
import axios from "axios";
import "../styles/admin.scss";

const Admin = () => {
  const url = process.env.REACT_APP_URL;
  const [reload, setReload] = useState(false);
  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState({
    email: "",
    roleid: ""
  });

  useEffect(() => {
    axios
      .get(`${url}/audit/roles`)
      .then((res) => setRoles(res.data))
      .catch((err) => console.error("Failed to load roles", err));

    fetchUsers();
  }, [reload]);

  const handleToggleBlock = async (userId, currentBlockedStatus) => {
    try {
      await axios.put(`${url}/audit/users/${userId}/block`, {
        blocked: !currentBlockedStatus,
      });
      fetchUsers(); // Refresh the list
    } catch (err) {
      console.error("Failed to update block status", err);
      alert("Error updating block status");
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const fetchUsers = () => {
    axios
      .get(`${url}/audit/users`)
      .then((res) => setUsers(res.data))
      .catch((err) => console.error("Failed to load users", err));
  };

  const handleRoleChange = async (userId, newRoleId) => {
    try {
      await axios.put(`${url}/audit/users/${userId}/role`, {
        role_id: newRoleId,
      });
      fetchUsers(); // Refresh after update
    } catch (err) {
      console.error("Failed to update role", err);
      alert("Error updating role");
    }
  };

  const handleDelete = async (userId) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;
    try {
      await axios.delete(`${url}/audit/users/${userId}`);
      fetchUsers(); // Refresh after deletion
    } catch (err) {
      console.error("Failed to delete user", err);
      alert("Error deleting user");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${url}/audit/add-user`, formData);
      alert("User added successfully");
      setFormData({ email: "", roleid: "" });
      setReload(!reload);
    } catch (err) {
      console.error("Failed to add user", err);
      if (err.status == 409) {
        alert(err.response.data.message);
      } else {
        alert("Error adding user");
      }
    }
  };

  return (
    <div className="add-user">
      <h2 className="add-user__title">Create a New User</h2>
      <form className="add-user__form" onSubmit={handleSubmit}>
        <div className="add-user__field">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        <div className="add-user__field">
          <label>Role</label>
          <select
            name="roleid"
            value={formData.roleid}
            onChange={handleChange}
            required
          >
            <option value="">Select role</option>
            {roles.map((role) => (
              <option key={role.role_id} value={role.role_id}>
                {role.role_name}
              </option>
            ))}
          </select>
        </div>
        <button className="add-user__submit" type="submit">
          Add User
        </button>
      </form>
      <hr />
      {users.length > 0 && (
        <div>
          <h2 className="add-user__title">List of Users</h2>
          <div className="admin-users-table-wrapper"></div>
          <table className="admin-users-table">
            <thead>
              <tr>
                <th>Email</th>
                <th>Role</th>
                <th>Blocked</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.user_id}>
                  <td data-label="Email">{user.email}</td>
                  <td data-label="Role">
                    <select
                      value={user.role_id}
                      onChange={(e) =>
                        handleRoleChange(user.user_id, e.target.value)
                      }
                    >
                      {roles.map((role) => (
                        <option key={role.role_id} value={role.role_id}>
                          {role.role_name}
                        </option>
                      ))}
                    </select>
                  </td>

                  <td data-label="Blocked">
                    <span
                      style={{
                        color: user.blocked ? "red" : "green",
                        fontWeight: "bold",
                        marginRight: "10px",
                      }}
                    >
                      {user.blocked ? "Blocked" : "Active"}
                    </span>
                    <button
                      onClick={() =>
                        handleToggleBlock(user.user_id, user.blocked)
                      }
                      style={{
                        backgroundColor: user.blocked ? "#4CAF50" : "#f44336", // Green for unblock, red for block
                        color: "#fff",
                        border: "none",
                        padding: "6px 10px",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      {user.blocked ? "Unblock User" : "Block User"}
                    </button>
                  </td>

                  <td data-label="Delete">
                    <button onClick={() => handleDelete(user.user_id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Admin;
